export default "__VITE_ASSET__BUBB6FA2__"